/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameDocumentRequest
 */
export interface RenameDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameDocumentRequest
     */
    newFileName: string;
}

/**
 * Check if a given object implements the RenameDocumentRequest interface.
 */
export function instanceOfRenameDocumentRequest(value: object): value is RenameDocumentRequest {
    if (!('newFileName' in value) || value['newFileName'] === undefined) return false;
    return true;
}

export function RenameDocumentRequestFromJSON(json: any): RenameDocumentRequest {
    return RenameDocumentRequestFromJSONTyped(json, false);
}

export function RenameDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newFileName': json['newFileName'],
    };
}

export function RenameDocumentRequestToJSON(json: any): RenameDocumentRequest {
    return RenameDocumentRequestToJSONTyped(json, false);
}

export function RenameDocumentRequestToJSONTyped(value?: RenameDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newFileName': value['newFileName'],
    };
}

